/**
 * Promise 工具
 */
export default class PromiseUtil {

    /**
     * 等待
     * @param time 时长（秒）
     * @example
     * await PromiseUtil.sleep(1);
     */
    public static sleep(time: number): Promise<void> {
        return new Promise(res => cc.Canvas.instance.scheduleOnce(res, time));
    }

    /** 下一帧执行 */
    public static async nextFrame() {
        return await new Promise<void>((resolve, reject) => {
            resolve();
        });
    }

}
